import "./film-page.css";

export default function FilmPage() {
    return (
        <>
          <section className="page-container">
            <iframe 
              width="560" 
              height="315" 
              src="https://www.youtube.com/embed/-Ib1vvFMVo4" 
              title="YouTube video player" 
              frameborder="0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
              allowFullScreen>
            </iframe>
          </section>
        </>
      )

} 